import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import { User, UserAccess } from 'src/app/services/userStore/user.model';
import { Observable, Subject } from 'rxjs';
import { Globals } from 'src/app/globals';

@Injectable({
  providedIn: 'root'
})
export class AppLoadService {

  userObject: User;

  public dbVersion: number;

  constructor(
    public globals: Globals,
  ) {
    this.dbVersion = globals.dbVersion_POWER_PORTAL_DB;
  }

  initializeApp(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, 3000);
    });
  }

  getUser(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      this.getUserObject((results) => {
        if (results.itemFound) {
          this.updateUserObject(results.value);
        }
        if (!results.itemFound) {
          this.updateUserObject("error");
        }
        resolve();
      });
    });
  }


  private userObject_changed = new Subject<any>();
  get userObject_DataChanged() {
    return this.userObject_changed.asObservable();
  }
  updateUserObject(data) {
    this.userObject = data;
    this.userObject_changed.next(data);
  }


  powerPortal_IDB_upgradeNeeded = (request) => {

    //1) INFO
    var storeAddOne = "info";
    var db = request.result;
    if (db.objectStoreNames.contains(storeAddOne)) {
      db.deleteObjectStore(storeAddOne);
    }
    var store = db.createObjectStore(storeAddOne, {
      keyPath: "itemName"
    });

    //2) ERROR LOG
    var storeAddTwo = "errorLog";
    var dbTwo = request.result;
    if (dbTwo.objectStoreNames.contains(storeAddTwo)) {
      dbTwo.deleteObjectStore(storeAddTwo);
    }
    var storetwo = db.createObjectStore(storeAddTwo, {
      keyPath: "id"
    });
  }


  updateUser = (data, callBack) => {
    var searchString = "userObject";
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      message: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;
      var updateData = () => {
        var objectStore = db.transaction(objectStoreName, 'readwrite').objectStore(objectStoreName);
        var db_op_req = objectStore.put(data);

        db_op_req.onsuccess = (event) => {
          resultObj.message = "success";
          callBack(resultObj);
        };
        db_op_req.onerror = (event) => {
          resultObj.message = "error";
          callBack(resultObj);
        };
      };

      request.onupgradeneeded = (event) => {
        this.powerPortal_IDB_upgradeNeeded(request);
      };

      request.onsuccess = (event) => {
        db = request.result;
        updateData();
      };

      request.onerror = (event) => {
        resultObj.message = "error";
        callBack(resultObj);
      };

    } else {
      resultObj.message = "notSupported";
      callBack(resultObj);
    }
  };

  getUserObject = (callBack) => {
    var itemName = "userObject";
    var objectStoreName = "info";
    var storeNames = [objectStoreName];

    var resultObj = {
      itemFound: false,
      value: ""
    }

    if (indexedDB) {
      var request = indexedDB.open('POWER_PORTAL_DB', this.dbVersion);
      var db;

      var getData = () => {
        var transaction = db.transaction(objectStoreName, 'readwrite')
        var objectStore = transaction.objectStore(objectStoreName);
        var dataResults = [];

        transaction.oncomplete = (event) => {
          callBack(resultObj);
        };


        objectStore.openCursor().onsuccess = (event) => {
          var itemFound = false;
          var cursor = event.target.result;
          if (cursor) {
            if (cursor.value.itemName.indexOf(itemName) !== -1) {
              itemFound = true;
              resultObj.itemFound = true;
              resultObj.value = cursor.value.value;
              callBack(resultObj);
            } else {
              cursor.continue();
            }
          } else {

          }

          if (!itemFound) {

          }
        };
      };

      request.onupgradeneeded = (event) => {
        this.powerPortal_IDB_upgradeNeeded(request);
      };

      request.onsuccess = function (event) {
        db = request.result;
        getData();
      };

      request.onerror = function (event) {
        callBack(resultObj);
      };

    } else {
      callBack(resultObj);
    }
  };
}


